import { IQueryTypeFragments } from '../../QueryFragments';
import { QueryType } from '../Default';

const brandFragment = `
    on ${QueryType.product} {
        brand
    }
`;

export const brandFragments = (): IQueryTypeFragments => {
    return {
        [QueryType.product]: brandFragment
    };
};
